export function InlineLoader() {
  return <span className="shimmer-inline" role="status" aria-label="Loading" />;
}

export function ThreeDotSpinner(props) {
  return (
    <div className={`loader ${props.className}`}>
      <div className="shimmer-ring" role="status" aria-label="Loading" />
    </div>
  );
}

// Drop into a <tbody> in place of the row map while data is loading.
// Bar widths are varied per cell so the row doesn't look like a solid block.
export function TableSkeleton({ rows = 5, columns = 5 }) {
  const widths = [85, 60, 95, 45, 70];
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <tr className="skeleton-row" key={r}>
          {Array.from({ length: columns }).map((_, c) => (
            <td key={c}>
              <span
                className="skeleton-bar"
                style={{ width: `${widths[(r + c) % widths.length]}%` }}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

// Matches the .dashboard-cards / .card-content / .card-img-view markup so it
// occupies the same space as the real stat card once data arrives.
export function DashboardCardSkeleton() {
  return (
    <div className="dashboard-cards">
      <div className="card-content">
        <span className="skeleton-bar" style={{ width: "70%", height: 10, marginBottom: 12 }} />
        <span className="skeleton-bar" style={{ width: "45%", height: 22 }} />
      </div>
      <div className="card-img-view">
        <span className="skeleton-bar skeleton-card-icon" />
      </div>
    </div>
  );
}
